import React from 'react';
import PropTypes from 'prop-types';
import { Text, Title, Image, Row, View, Button } from 'modules/styled';

const coin = require('public/img/relevantcoin.png');
const upvote = require('public/img/upvote.png');

const OnboardingModal = (props) => (
  <View>
    <Row sx={{ mt: 6 }}>
      <Image
        resizeMode={'contain'}
        sx={{ width: 2.8 * 8, height: 2.8 * 8, mr: 0.75 * 8.01 }}
        source={require('public/img/r-emoji.png')}
      />
      <Title>Build Trust</Title>
    </Row>
    <Text sx={{ mt: 1, fontSize: 2 }}>
      Boost your Reputation by posting quality comments. As your Reputation grows so does
      your voting impact, and your earnings. The most reputable users become community
      leaders.
    </Text>

    <Row sx={{ mt: 6 }}>
      <Image
        resizeMode={'contain'}
        sx={{ width: 2.8 * 8, height: 2.8 * 8, mr: 0.75 * 8.01 }}
        source={upvote}
      />
      <Title>Curate Content</Title>
    </Row>
    <Text sx={{ mt: 1, fontSize: 2 }}>
      Share links, upvote quality content and downvote spam.
    </Text>

    <Row sx={{ mt: 6 }}>
      <Image
        resizeMode={'contain'}
        sx={{ width: 2.8 * 8, height: 2.8 * 8, mr: 0.75 * 8.01 }}
        source={coin}
      />
      <Title>Get Rewards</Title>
    </Row>

    <Text sx={{ mt: 1, fontSize: 2 }}>
      Earn coins for upvoting quality links. Coins can be traded in for Relevant Tokens
      that represent ownership in the platform.
    </Text>
    <View sx={{ alignItems: 'flex-start', mt: 3 }}>
      <Button onPress={() => props.close()}>Got It</Button>
    </View>
  </View>
);

OnboardingModal.propTypes = {
  close: PropTypes.func,
};

export default OnboardingModal;
